import React, { useRef, useEffect } from 'react'
import styles from './NumberInput.module.scss'
import { TextInputProps } from '../../../types/common-types'
import { generateId } from '../../../utils/helpers'
import InputMask from 'react-input-mask'

function NumberInput({
  disabled,
  lang,
  content,
  onChange,
  checkLabel,
  checkValue,
  checkChange,
  value,
  className,
  valid,
  required,
  focus,
  onBlur,
  mask,
  onKeyDown,
  ...props
}: TextInputProps) {
  const idRef = useRef(generateId(16))
  const inputRef = useRef<HTMLInputElement>(null)
  useEffect(() => {
    if (focus && inputRef.current) {
      inputRef.current.focus()
    }
  }, [focus])

  return (
    <label
      htmlFor={idRef.current}
      className={`${className || ''} ${styles.label}`.trim()}
    >
      {content?.label?.[lang]?.length > 0 ? (
        <p className={styles.labelText}>
          {content.label[lang]}
          {required && <span className={styles.required}></span>}
        </p>
      ) : null}
      <input
        data-test-id={props.testName}
        id={idRef.current}
        disabled={disabled}
        className={`${styles.input} ${valid ? '' : styles.invalid}`}
        inputMode="numeric"
        pattern="[0-9]*"
        placeholder={content?.placeholder?.[lang]}
        onKeyDown={onKeyDown}
        onChange={event => {
            if (event.target) {
              let value = event.target.value.replace(/^\s+/, '');
              value = value.replace(/\D/g, '');
              if (value !== event.target.value) {
                event.target.value = value;
              }
              onChange(value, event);
            }
          }}
        value={value}
        onBlur={onBlur}
      />
      {}
      {!valid && content.invalidText ? (
        <span className={styles.invalidText} data-test-id={props.testErrorName}>
          {content.invalidText[lang]}
        </span>
      ) : null}
    </label>
  )
}

export default NumberInput
